// @owners { team: patients }
import { Button, Illustration } from '@alto/design-system';
import { CommsVerificationCard } from '@alto/features';
import * as React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { getImageAltText } from '~shared/assets/images/getImageAltText';
import { getCompanyName } from '~shared/config/getCompanyName';
import { COMMS_CHANNEL } from '~shared/constants';
import { useNavigateAfterVerification } from '../hooks/useNavigateAfterVerification';

type Props = {
  readonly commsChannel: keyof typeof COMMS_CHANNEL;
  readonly authorized: boolean;
};

export const CommsVerificationSuccess = ({ authorized, commsChannel }: Props) => {
  const navigateToNextRoute = useNavigateAfterVerification(authorized);

  return (
    <CommsVerificationCard
      headerIcon={
        <Illustration
          size="lg"
          source={getImage('verifiedCheckmark')}
          accessibilityLabel={getImageAltText('greenCheckmark')}
        />
      }
      title={`${COMMS_CHANNEL[commsChannel]} verified!`}
    >
      <Button
        onPress={navigateToNextRoute}
        label={`Continue to ${getCompanyName()}`}
        accessibilityLabel={`Continue to ${getCompanyName()}`}
        width="full"
      />
    </CommsVerificationCard>
  );
};
